let accessToken = localStorage.getItem("briefToken") || "";
export const setAccessToken = (token: string) => {
  accessToken = token;
  token
    ? localStorage.setItem("briefToken", token)
    : localStorage.removeItem("briefToken");
};

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
  }
}
export async function api<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const isFormData = options.body instanceof FormData;
  const response = await fetch(`/api${path}`, {
    ...options,
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      ...(options.headers || {}),
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok)
    throw new ApiError(body.message || body.error || "请求失败", response.status);
  return body as T;
}

export async function apiBlob(path: string): Promise<Blob> {
  const response = await fetch(`/api${path}`, {
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new ApiError(body.message || body.error || "文件读取失败", response.status);
  }
  return response.blob();
}

export type StreamEvent =
  | { type: "progress"; key: string; label: string }
  | { type: "delta"; text: string }
  | { type: "complete"; brief: unknown }
  | { type: "error"; message: string };

export async function apiStream(
  path: string,
  body: unknown,
  onEvent: (event: StreamEvent) => void,
) {
  const response = await fetch(`/api${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new ApiError(payload.error || "请求失败", response.status);
  }
  const handleLine = (line: string) => {
    if (!line.trim()) return;
    const event = JSON.parse(line) as StreamEvent;
    if (event.type === "error") throw new ApiError(event.message, 502);
    onEvent(event);
  };
  if (!response.body) {
    const payload = await response.text();
    if (!payload.trim()) throw new ApiError("未收到服务器回复", 502);
    for (const line of payload.split("\n")) handleLine(line);
    return;
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
    const lines = buffer.split("\n");
    buffer = lines.pop() || "";
    for (const line of lines) handleLine(line);
    if (done) {
      if (buffer.trim()) handleLine(buffer);
      break;
    }
  }
}
